module.exports = __webpack_public_path__ + "static/new-banner-e5afbfd389e3c6c7f3e20054592eef84.jpg";